import React from "react";
import Axios from "axios";

import { Avatar, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Activity() {
  const [activity, setactivity] = React.useState("");

  const fetchStats = async () => {
    const { data } = await Axios({
      method: "get",
      url: "/api/activity/gdinvestorinvite",
    });
    setactivity(data.data);
  };
  const navigate = useNavigate();
  React.useEffect(() => {
    fetchStats();
  }, []);
  if (activity === "") {
    return <CircularProgress />;
  } else if (activity === null) return <div>No Invites</div>;
  else
    return (
      <div className="container admin-user-activity">
        {activity ? (
          <>
            <table>
              <tr>
                <th className="white">Sender</th>
                <th className="white">GD Investor</th>
                <th className="white">Time</th>
              </tr>
              {activity.length > 0 &&
                activity.map((res, i) => (
                  <tr key={i} className="my-2 pt-2">
                    <td
                      onClick={() =>
                        navigate(
                          `/admin/user-activity?tab=13&userid=${res.userid?._id}`
                        )
                      }
                      className="pointer my-2 pt-2"
                    >
                      <Avatar src={res.userid ? res.userid.avatar : ""} />
                      {res.userid
                        ? `${res.userid.name} (${res.userid.type})`
                        : ""}
                      {res.userid.firstname}
                    </td>
                    <td className="white my-2 pt-2">
                      <Avatar
                        src={
                          res.gi_id
                            ? "https://logo.clearbit.com/" + res.gi_id.Website
                            : ""
                        }
                        sx={{ width: 50, height: 50 }}
                        className="no-padding"
                      ></Avatar>
                      {res.gi_id?.InvestorName}
                    </td>
                    <td className="white pt-2">
                      {new Date(res.updatedAt).toLocaleTimeString()}{" "}
                      {new Date(res.updatedAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
            </table>
          </>
        ) : (
          ""
        )}
      </div>
    );
}
